import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import Button from 'components/formElements/Button'
import { Calendar } from 'primereact/calendar'
import { useState } from 'react'
import useEditor from 'hooks/useEditor'
import Icons from 'assets/icons'
import { useDispatch, useSelector } from 'react-redux'
import { setBillsData, setEdittedRow, setInvoiceStatues } from 'redux/features/projectDetail/projectDetailSlice'
import { useEffect } from 'react'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import FileUploadEditor from 'components/fileUploadEdıtor/FıleUploadEdıtor'
import { useParams } from 'react-router-dom'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { currencyFormatter } from 'utils/CurrencyFormatter'
import { InputText } from 'primereact/inputtext'
import moment from 'moment'
import { Dialog } from 'primereact/dialog'
import InvoiceInlineApprovalModalContent from 'components/modalContent/InvoiceInlineApprovalModal'
import { closeInlineApprovalModal } from 'redux/features/general/generalSlice'
import { userInfo } from 'utils/Auth'
import { isAdmin } from 'utils/Constants'
import DefaultSelect from 'components/formElements/DefaultSelect'

const BillingStatement = () => {
	const initialFilterOptions = { searchString: '', sourceType: '', responsibleRole: null, invoiceNo: '', estimatedDate: '', status: null }

	const { projectId } = useParams()
	const [getBillsData] = useRequest()
	const [getInvoicesStatus] = useRequest()
	const [request] = useRequest()

	const { projectDetail, general } = useSelector((state) => state)

	const { invoiceStatuses, billsData, edittedRow } = projectDetail
	const [filterOptions, setFilterOptions] = useState(initialFilterOptions)

	const [onFirstLoad, setOnFirstLoad] = useState(true)
	const [sourceTypes, setSourceTypes] = useState([])
	const [filterStatus, setFilterStatus] = useState()
	const [personStatus, setPersonStatus] = useState('')
	const { invoiceInlineApprovalModal } = general
	const [loading, setLoading] = useState(true)
	const [isUpdate, setIsUpdate] = useState()

	const { showToast } = useToast()
	const dispatch = useDispatch()
	const { textEditor, rowEditorBody, currencyEditor, calendarShortDateEditor, InvoiceSelectEditorForReports } = useEditor()

	useEffect(() => {
		setIsUpdate(userInfo['Invoice.update'].includes('True'))
	}, [userInfo])
	useEffect(() => {
		setOnFirstLoad(false)
	}, [])
	useEffect(() => {
		getBillsData('/Invoices/GetAllInvoices', {
			method: 'GET',
		}).then((res) => {
			if (res?.data?.ok) {
				setLoading(false)
				const data = res.data.result

				const now = Date.now();

				let sortDate = data.sort(function (a, b) {
					var c = new Date(a.estimatedDate);
					var d = new Date(b.estimatedDate);
					return (now - d) - (now - c);
				});


				dispatch(setBillsData(sortDate))
				setSourceTypes(
					data.filter((a, i) => data.findIndex((s) => a.sourceType === s.sourceType) === i).map((s) => ({ label: s.sourceType, value: s.sourceType }))
				)

				if (onFirstLoad && isAdmin) {
					const filteredStatuses = data
						.filter((a, i) => data.findIndex((s) => a.invoiceStatusId === s.invoiceStatusId) === i)
						?.map((s) => ({ label: s.status.name, value: s.status.id }))
					setFilterStatus(filteredStatuses)
					setFilterOptions({ ...filterOptions, status: [...filteredStatuses.filter((s) => (s.label.toLowerCase().includes('bekliyor') || (s.label.toLowerCase().includes('kesilebilir'))))] })
				}
				//console.log("1234567",data.map(dt => dt.responsibleRole == "AM" ? {...dt , projectRoles : dt.project.projectRoles.filter(a => a.projectRole.name == "AccountManager")} : {...dt ,projectRoles : dt.project.projectRoles.filter(a => a.projectRole.name == "ProjectManager")}));
				// setPersonStatus(prev => {
				//   console.log(prev);
				//   let newData = data.map(dt => dt.responsibleRole == "AM" ? {...dt , projectRoles : dt.project.projectRoles.filter(a => a.projectRole.name == "AccountManager")} : {...dt , projectRoles : dt.project.projectRoles.filter(a => a.projectRole.name == "ProjectManager")})
				//   return newData.filter((f,i) => newData.findIndex((s) => f.projectRoles[0].userId === s.projectRoles[0].userId) === i)
				// })
				setPersonStatus(
					data
						.filter((a, i) => data.findIndex((s) => a.responsibleUserId === s.responsibleUserId) === i)
						.map((u) => ({ label: u.responsibleUser, value: u.responsibleUserId }))
				)
			}
		})
		getInvoicesStatus('/InvoiceStatus/GetAllInvoiceStatuses', { method: 'GET' }).then((res) => {
			if (res?.data?.ok) {
				dispatch(
					setInvoiceStatues(
						res.data.result.map((d) => {
							return { value: d.id, label: d.name }
						})
					)
				)
			}
		})
		// }
	}, [projectId])
	const exportExcel = () => {
		import('xlsx').then((xlsx) => {
			const worksheet = xlsx.utils.json_to_sheet(billsData)
			const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] }
			const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' })
			saveAsExcelFile(excelBuffer, 'bill')
		})
	}
	const saveAsExcelFile = (buffer, fileName) => {
		import('file-saver').then((module) => {
			if (module && module.default) {
				let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
				let EXCEL_EXTENSION = '.xlsx'
				const data = new Blob([buffer], {
					type: EXCEL_TYPE,
				})

				module.default.saveAs(data, fileName + EXCEL_EXTENSION)
			}
		})
	}
	const resetFilter = () => {
		if (!isAdmin) {
			setFilterOptions(initialFilterOptions)
		} else {
			setFilterOptions({ ...filterOptions, searchString: '', sourceType: null, responsibleRole: null, invoiceNo: '', estimatedDate: '' })
		}
	}
	const acceptFunc = (rowdata) => {
		request('/Invoices/DeleteInvoices', {
			method: 'DELETE',
			data: {
				id: rowdata.id,
			},
		}).then((res) => {
			if (res?.data) {
				getBillsData('/Invoices/GetAllInvoices', {
					method: 'GET',
				}).then((res) => {
					if (res.data.ok) {
						const data = res.data.result
						dispatch(setBillsData(data))
						showToast('Fatura Bilgisi Silindi.', 'success')
					}
				})
			}
		})
	}
	const deleteButton = (rowdata) => {
		return (
			<Icons.deleteNotFill
				onClick={() => {
					confirmDialog({
						message: 'Kaydı silmek istiyor musunuz?',
						header: '',
						icon: 'pi pi-info-circle',
						acceptClassName: 'p-button-danger',
						accept: () => acceptFunc(rowdata),
					})
				}}
				className='text-danger cursor-pointer'
			/>
		)
	}
	const renderHeader2 = () => {
		return (
			<div className='flex justify-content-between '>
				<div className='d-flex flex-wrap gap-2'>
					<span className='p-input-icon-left '>
						<i className="pi pi-search" />
						<InputText
							className='default-input'
							style={{ maxWidth: '10rem' }}
							inputId='dropdown'
							placeholder='Proje/Müşteri'
							value={filterOptions.searchString}
							onChange={(e) => handleChnage(e.target, 'searchString')}
						/>
					</span>
					<div className=''>
						<DefaultSelect
							className='w-fit-content'
							isClearable
							placeholder='Fatura Tipi'
							value={filterOptions?.sourceType ? { label: filterOptions.sourceType, value: filterOptions.sourceType } : ''}
							selectOptions={sourceTypes}
							handleChange={(e) => handleChnage(e, 'sourceType')}
						/>
					</div>
					{isAdmin && (
						<span className=''>
							<DefaultSelect
								className='w-fit-content'
								isClearable
								placeholder='Sorumlu Kişi'
								value={filterOptions?.responsibleRole ? filterOptions?.responsibleRole : ''}
								selectOptions={personStatus}
								handleChange={(e) => handleChnage(e, 'responsibleRole')}
							/>
						</span>
					)}
					<span className=''>
						<InputText
							style={{ maxWidth: '10rem' }}
							inputId='dropdown'
							placeholder='Fatura No'
							value={filterOptions.invoiceNo}
							onChange={(e) => handleChnage(e.target, 'invoiceNo')}
						/>
					</span>
					<span className=''>
						<Calendar
							style={{ width: '12rem' }}
							view='month'
							dateFormat='mm/yy'
							placeholder='Kesilecek Ay'
							value={filterOptions.estimatedDate}
							onChange={(e) => handleChnage(e, 'estimatedDate')}
						/>
					</span>
					{/* {isAdmin && <span className="p-input-icon-left ml-2">
            <i className="pi pi-search" />
            <Dropdown showClear inputId="dropdown" placeholder="Fatura Durumu" value={globalFilterValue3} options={filterStatus} onChange={onGlobalFilterChange3} optionLabel="status.name" />
          </span>} */}
					{isAdmin && (
						<div className=''>
							<DefaultSelect
								handleChange={(e) => handleChnage(e, 'status', true)}
								isMulti
								value={filterOptions.status ? filterOptions.status : null}
								selectOptions={filterStatus}
								placeholder='Fatura Durumu'
							/>
						</div>
					)}
				</div>
				<div>
					<div className='filters-right justify-content-space-between'>
						<Button
							style={{ height: '47px', minHeight: 'unset' }}
							className={'btn-primary p-1 mr-3'}
							title={'Filtreleri Temizle'}
							handleClick={resetFilter}
						/>
						<Button
							className='comment-box-absolute-btn'
							title='Excel'
							style={{ height: '47px', backgroundColor: '#00A15D', borderColor: '#00A15D' }}
							handleClick={exportExcel}
						/>
					</div>
				</div>
			</div>
		)
	}

	const handleChnage = (e, name, array) => {
		if (name == 'isArchive') {
			setFilterOptions((prev) => ({ ...prev, [name]: e.value }))
		} else if (e == null || e.length == 0 || e.value == '') {
			setFilterOptions((prev) => ({ ...prev, [name]: null }))
		} else if (name == 'responsibleRole') {
			setFilterOptions((prev) => ({
				...prev,
				[name]: e && e != undefined ? e : null,
			}))
		} else if (name == 'estimatedDate') {
			setFilterOptions((prev) => ({
				...prev,
				[name]: e.value ? e.value : null,
			}))
		} else {
			if (array) {
				setFilterOptions((prev) => ({
					...prev,
					[name]: e && e != undefined ? e : e.length > 0 && e,
				}))
			} else {
				setFilterOptions((prev) => ({
					...prev,
					[name]: e.value && e.value != undefined ? e.value : e.length > 0 && e[0].value,
				}))
			}
		}
	}

	const onRowEditComplete1 = (e) => {
		let _products2 = [...billsData]
		let { index } = e
		_products2[index] = edittedRow

		request('/Invoices/UpdateInvoices', {
			method: 'PUT',
			data: { ...edittedRow, project: null, amount: edittedRow?.amount?.toString() },
		}).then((res) => {
			if (res?.data) {
				getBillsData('/Invoices/GetAllInvoices', {
					method: 'GET',
				}).then((res) => {
					if (res.data.ok) {
						const data = res.data.result

						dispatch(setBillsData(data))
						showToast('Fatura Bilgisi Güncellendi.', 'success')
					}
					dispatch(setEdittedRow({}))
				})
			}
		})
	}

	const header2 = renderHeader2()
	const paginatorLeft = <Button type='button' className='p-button-text' />
	const paginatorRight = <Button type='button' className='p-button-text' />
	const handleCloseInlineApprovalModal = () => {
		dispatch(closeInlineApprovalModal())
	}
	const filteredBills = billsData.filter((d) => {
		const keys = Object.keys(filterOptions)
		let rt = [true]
		if (keys.length > 0) {
			keys.forEach((k) => {
				if (filterOptions[k]) {
					if (k == 'searchString') {
						let uniName = (d.project.name + d.project.customerName).toLocaleLowerCase('tr')
						//console.log(uniName, filterOptions[k], "UNINAME");
						rt.push(uniName.match(filterOptions[k].toLocaleLowerCase('tr')))
					} else if (k == 'invoiceNo') {
						let uniName = d?.invoiceNo?.toLocaleLowerCase('tr')
						rt.push(uniName?.match(filterOptions[k]?.toLocaleLowerCase('tr')))
					} else if (k == 'sourceType') {
						rt.push(d.sourceType == filterOptions.sourceType)
					} else if (k == 'estimatedDate') {
						rt.push(moment(d?.estimatedDate)?.format('LL') == moment(filterOptions?.estimatedDate)?.format('LL'))
					} else if (k == 'status') {
						console.log(filterOptions[k].map((e) => e.value).includes(d.status.id), 'filterOptions[k]')
						rt.push(filterOptions[k].map((e) => e.value).includes(d.status.id))
					} else if (k == 'responsibleRole') {
						rt.push(d.responsibleUserId == filterOptions[k].value)
					}
				}
			})
		}
		return rt.every((r) => r)
	})
	return (
		userInfo['Invoice.read']?.includes('True') && (
			<AnimatedSpan className='page-container d-flex flex-column'>
				<ConfirmDialog />
				<Dialog draggable={false} visible={invoiceInlineApprovalModal.open} onHide={handleCloseInlineApprovalModal}>
					<InvoiceInlineApprovalModalContent handleClose={handleCloseInlineApprovalModal} approvalModal={invoiceInlineApprovalModal} />
				</Dialog>
				<div className='row-margin-x' >
					<div className='col-md-12'>
						<DataTable
							stripedRows
							paginator
							responsiveLayout='scroll'
							paginatorTemplate='CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown'
							currentPageReportTemplate='Showing {first} to {last} of {totalRecords}'
							rows={25}
							className='p-1'
							paginatorLeft={paginatorLeft}
							paginatorRight={paginatorRight}
							loading={loading}
							header={header2}
							editMode='row'
							dataKey='id'
							onRowEditComplete={onRowEditComplete1}
							value={filteredBills}
							onRowEditInit={(e) => dispatch(setEdittedRow(e.data))}
						>
							<Column
								className='text-semi-bold text-sm'
								field='project.name'
								style={{ width: 'auto' }}
								header='Müşteri / Proje Adı '
								sortable='true'
								body={(rowData) => {
									return (
										<span>
											{rowData?.project?.customerName && `${rowData?.project?.customerName} -`} {rowData?.project?.name}
										</span>
									)
								}}
							/>
							<Column
								className='text-semi-bold text-sm'
								field='name'
								style={{ width: 'auto' }}
								header='Fatura Adımı'
								editor={(options) => textEditor(options)}
							/>

							<Column
								className='text-semi-bold text-sm'
								field='sourceType'
								style={{ width: 'auto' }}
								header='Proje Adımı'
								body={(rowData) => {
									return (
										<span>{rowData.sourceType == 0 || rowData.sourceType == '0' ? 'TURNKEY' : rowData?.sourceType?.toString()?.toUpperCase()}</span>
									)
								}}
							/>
							<Column
								className='text-semi-bold text-sm'
								field='responsibleRole'
								header='Sorumlu Kişi'
								style={{ width: 'auto' }}
								editor={(options) => textEditor(options)}
							/>
							<Column
								className='text-semi-bold text-sm'
								style={{ width: 'auto' }}
								headerClassName='text-bold bg-primary text-default'
								field='amount'
								body={(rowData) => {
									return (
										<span>
											{currencyFormatter(rowData.amount) + rowData.currency}
										</span>
									)
								}}
								header='Tutar'
								editor={(options) => currencyEditor(options)}
							/>
							<Column
								headerClassName='text-bold bg-primary text-default '
								className='text-semi-bold text-sm'
								field='invoiceNo'
								header='Fatura No'
								style={{ width: 'auto' }}
								editor={(options) => textEditor(options)}
							/>
							<Column
								className='text-semi-bold text-sm'
								field='invoicesDocuments'
								header='Ödeme Onayı'
								headerClassName='text-bold bg-primary text-default'
								style={{ width: 'auto' }}
								editor={(options) => (
									<FileUploadEditor
										addEndpoint='/Invoices/AddInvoiceDocuments'
										deleteEndpoint='/Invoices/DeleteInvoiceDocuments'
										idName='InvoiceId'
										options={options}
									/>
								)}
								body={(rowData) => (
									<ul className='list-style-none'>
										{rowData.invoicesDocuments &&
											rowData.invoicesDocuments.map((p, i) => (
												<li key={i}>
													<a
														download={p.fileName}
														href={`data:${p.documentType};base64,${p.data}`}
														className='text-primary text-underlined cursor-pointer mr-2 word-break'
													>
														{p?.fileName}
													</a>
												</li>
											))}
									</ul>
								)}
							/>
							<Column
								className='text-semi-bold text-sm'
								headerClassName='text-bold bg-primary text-default'
								field='estimatedDate'
								header='Kesilecek Ay'
								style={{ width: 'auto' }}
								sortable='true'
								body={(rowData) => {
									const expectedDate = rowData.estimatedDate && moment(rowData.estimatedDate)
									const diff = rowData.estimatedDate && moment(new Date(), 'YYYY-MM-DD').diff(expectedDate.format('YYYY-MM-DD'), 'month')
									return (
										<span className={diff > 0 && rowData.invoiceStatusId != 1 && rowData.invoiceStatusId != 7 ? 'text-danger' : ''}>
											{' '}
											<span>{expectedDate && expectedDate.format('YYYY-MMMM').trim()}</span>{' '}
											<span>{diff > 0 && rowData.invoiceStatusId != 1 && rowData.invoiceStatusId != 7 && 'Süresi Geçti'}</span>
										</span>
									)
								}}
								editor={(options) => calendarShortDateEditor(options)}
							/>

							<Column
								className='text-semi-bold'
								field='invoiceStatusId'
								header='Durum'
								style={{ width: 'auto' }}
								headerClassName='text-bold bg-primary text-default'
								sortable='true'
								body={(rowData) => {
									return (
										<span className={rowData.status.id == 1 ? 'alert-success' : rowData.status.id == 3 ? 'alert-warning' : 'alert-info'}>
											{rowData.status.name}
										</span>
									)
								}}
								editor={(options) => isUpdate && InvoiceSelectEditorForReports({ ...options }, invoiceStatuses)}
							/>
							<Column rowEditor style={{ width: '3rem' }} body={(row, d) => rowEditorBody(d)} headerClassName='text-bold bg-primary text-default' />
							<Column
								field='action'
								style={{ width: '3rem' }}
								headerClassName='text-bold bg-primary text-default'
								className='text-semi-bold '
								body={(rowData) => deleteButton(rowData, '/Invoices/DeleteInvoices', 'invoices')}
							/>
						</DataTable>
					</div>
				</div>
			</AnimatedSpan>
		)
	)
}

export default BillingStatement
